export function getCookie(name) {
  var cookieValue = null;
  if (document.cookie && document.cookie !== "") {
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i].trim();

      if (cookie.substring(0, name.length + 1) === name + "=") {
        cookieValue = decodeURIComponent(cookie.substring(name.length + 1));
        break;
      }
    }
  }

  return cookieValue;
}

export function gup(name, url) {
  if (!url) url = location.href;
  name = name.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
  var regexS = "[\\?&]" + name + "=([^&#]*)";
  var regex = new RegExp(regexS);
  var results = regex.exec(url);
  return results == null ? null : decodeURIComponent(results[1]);
}

// A post-login target from the query string: same-site paths only. "//host"
// and "/\host" are other sites to the browser, "javascript:" runs code, and
// browsers drop tabs/newlines from URLs, so "/\t/host" would become "//host".
export function safeRedirect(path) {
  const sameSite =
    typeof path === "string" &&
    /^\/(?![/\\])/.test(path) &&
    !/\s/.test(path) &&
    ![...path].some(ch => ch < " " || ch === "\u007f");
  return sameSite ? path : "/";
}
